import { formatDate } from '@/lib/utils/time'

interface DateSeparatorProps {
  timestamp: number
}

export function DateSeparator({ timestamp }: DateSeparatorProps) {
  return (
    <div className="date-sep">
      <span className="date-sep-line" />
      <span className="date-sep-chip font-data">{formatDate(timestamp)}</span>
      <span className="date-sep-line" />
    </div>
  )
}
